import {getCookie} from "@helpers/cookie/cookie";
import {saveTokens} from "@containers/auth/helpers/helpers";
import {ITokensData} from "@containers/auth/types/auth";
import {IS_SEPARATED, ROOT_PATH, TRACK_PATH} from "@constants/config";

export interface IImpersonationActor {
	username: string,
	accountCode: string,
	// Whom the token is for in the account connected to: "admin" or a user login.
	login: string,
}

/**
 * The person behind an impersonation, read from the "act" claim of the access token;
 * null for an ordinary sign in.
 */
export const getImpersonationActor = (token: string | undefined = getCookie('token')): IImpersonationActor | null => {
	if (!token) {
		return null
	}
	try {
		const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
		const {act, sub} = JSON.parse(window.atob(payload))
		return act?.username ? {username: act.username, accountCode: act.accountCode, login: sub} : null
	} catch (e) {
		return null
	}
}

/**
 * Where to land in the next account: the same page, except the system pages, which only the
 * administrator's own account opens, and pages of one record, whose id means nothing there.
 * The system pages keep their records in the own account, so going back there stays on them.
 */
export const trackPathAfterSwitch = (toOwnAccount: boolean, pathname: string = window.location.pathname): string => {
	if (!pathname.startsWith(TRACK_PATH)) {
		return '/account/info'
	}
	if (pathname.startsWith(`${ROOT_PATH}admin`)) {
		return toOwnAccount ? pathname.slice(TRACK_PATH.length) : '/account/info'
	}
	const segments = pathname.slice(TRACK_PATH.length).split('/')
	const recordAt = segments.findIndex((segment) => /^\d+$/.test(segment))
	return (recordAt < 0 ? segments : segments.slice(0, recordAt)).join('/') || '/account/info'
}

/**
 * Hands the browser the tokens of another account and reloads: track1 moves its session over to
 * whoever the token cookies name, the standalone build starts over with them.
 */
export const switchToTokens = (tokens: ITokensData, trackPath: string) => {
	saveTokens(tokens)
	window.location.assign(IS_SEPARATED ? ROOT_PATH : `${TRACK_PATH}${trackPath}`)
}
